<template>
  <div class="action">
    <div>
      <div class="action__title">{{ action.title }}</div>
      <div class="action__desc">{{ action.desc }}</div>
    </div>
    <img src="../assets/action.png" />
  </div>
</template>

<script>
export default {
  name: "Action",
  props: {
    action: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  background: #77bc1f;
  color: #fff;
  margin: 0 auto;
  padding: 117px 56px 0 56px;
  min-height: 80vh;
  position: relative;
  max-width: 100vw;
  min-height: calc(100vh - 85px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 768px) {
    padding: 117px 40px 0 0;
    min-height: calc(100vh - 75px);
  }

  &__title {
    font-size: 20px;
    text-align: center;
    max-width: 677px;
    color: #fff;
    margin: 0 auto;
    @media (min-width: 768px) {
      font-size: 40px;
      line-height: 60px;
    }
  }

  &__desc {
    font-weight: 350;
    font-size: 16px;
    line-height: 24px;
    max-width: 677px;
    color: #fff;
    margin: 0 auto;
    margin-top: 28px;
    @media (min-width: 768px) {
      margin-top: 34px;
      font-size: 22px;
      line-height: 33px;
    }
  }

  img {
    max-width: 80vw;
    @media (min-width: 768px) {
      max-width: 80vw;
      max-height: 50vh;
    }
  }
}
</style>
